import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/App';
import './styles/App.css';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";


const firebaseConfig = {
    apiKey: "AIzaSyCq93xSrkhMOyyXni5dW26RUoB22Jjj6Ok",
    authDomain: "bfgoalsapp.firebaseapp.com",
    projectId: "bfgoalsapp",
    storageBucket: "bfgoalsapp.firebasestorage.app",
    messagingSenderId: "833414335868",
    appId: "1:833414335868:web:7d38d139dd86a2af5d28f9",
    measurementId: "G-G387Z669GY"
};


const firebaseapp = initializeApp(firebaseConfig);
const analytics = getAnalytics(firebaseapp);

const root = createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);